import { render } from "./DashboardRules.vue?vue&type=template&id=2a399831&scoped=true"
import script from "./DashboardRules.vue?vue&type=script&lang=js"
export * from "./DashboardRules.vue?vue&type=script&lang=js"

import "./DashboardRules.vue?vue&type=style&index=0&id=2a399831&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a399831"]])

export default __exports__